import { render, staticRenderFns } from "./zhizuo.vue?vue&type=template&id=165c7500&scoped=true"
import script from "./zhizuo.vue?vue&type=script&lang=js"
export * from "./zhizuo.vue?vue&type=script&lang=js"
import style0 from "./zhizuo.vue?vue&type=style&index=0&id=165c7500&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165c7500",
  null
  
)

export default component.exports